export default {
  render: function(content, domElement) {
    domElement.innerHTML = content;
  }
}



/** WEBPACK FOOTER **
 ** ./lib/renderer.js
 **/